import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { CancelCourtEventLauncherService } from '@court-event-modals/court-event-modals.module';
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';

import { CourtEventDetailsFacade } from '../../+store/court-event-details.facade';

@Component({
    selector: 'app-court-blocked-slot-item-details',
    templateUrl: './court-blocked-slot-item-details.component.html',
    styleUrls: ['./court-blocked-slot-item-details.component.scss'],
    standalone: false
})
export class CourtBlockedSlotItemDetailsComponent implements OnInit, OnDestroy {
    @Input() courtEventId: string;

    blockedSlot$ = this.courtEventDetailsFacade.blockedSlotDetails$;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private courtEventDetailsFacade: CourtEventDetailsFacade,
        private cancelCourtEventLauncherService: CancelCourtEventLauncherService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        this.courtEventDetailsFacade.loadBlockedSlotDetails(this.courtEventId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventDetailsFacade.loadBlockedSlotDetails(this.courtEventId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventDetailsFacade.clearLoadedBlockedSlotDetails();

        this.subscriptions.unsubscribe();
    }

    onCancelClicked() {
        const blockedSlot = this.courtEventDetailsFacade.getBlockedSlotDetailsSnapshot();
        this.cancelCourtEventLauncherService.openCancelCourtBlockedSlotModal(
            { blockedSlotId: blockedSlot.data.courtEventId, isRecurring: blockedSlot.data.recurring !== null },
            () => this.courtEventDetailsFacade.loadBlockedSlotDetails(this.courtEventId)
        );
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.courtEventId });
    }
}
